import { LoaderCircle } from 'lucide-react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export function ProtectedRoute() {
  const { user, demo, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div className="route-loading"><LoaderCircle className="spin" size={22}/><span>Preparando sua biblioteca…</span></div>
  }

  if (!user && !demo) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return <Outlet />
}
